import React from 'react'
import {Button} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {AuditPaneContext} from '../../context/AuditPane'
import {UserContext} from '../../context/User'
import GroupTabs from '../AuditDetailTab/GroupTabs'
import {getLastAuditPeriod, getNextAuditPeriod} from '../../utils/auditDatePeriodFormatter'
import auditRecurringFormatter from '../../utils/auditRecurringFormatter'

function AuditTemplateDetailTab({template, permission}) {
  const {t} = useTranslation()

  const paneState = React.useContext(AuditPaneContext)
  const user = React.useContext(UserContext)

  const compareFunction = (a, b) => {
    const firstVal = a.user_name.toUpperCase()
    const secondVal = b.user_name.toUpperCase()

    if (firstVal > secondVal) return 1
    if (firstVal < secondVal) return -1
    return 0
  }

  const renderAssignedUsers = () => {
    if (template.audit_users_attributes !== null) {
      return template.audit_users_attributes.sort(compareFunction).map((item, index) => (
        <span key={index} className="ap-pillbox ap-pillbox--20 ap-pillbox--white mb_5" disabled>
          {item.user_id.toString() === user.details.id.toString()
            ? item.user_name + ` (${t('audit.detail-tab.labels.self')})`
            : item.user_name}
        </span>
      ))
    } else {
      return null
    }
  }

  return (
    <div className="audit-detail-tab container">
      <div className="row pt_12">
        <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.methods')}</div>
        <div className="audit-detail-tab__label audit-detail-tab__label--value">
          {t(`audit.methods.${template.method}`)}
        </div>
      </div>

      <div className="row pt_12">
        <div className="col-md-6 pl_0">
          <div className="audit-detail-tab__label">
            {t('audit.detail-tab.labels.last_audit_period')}
          </div>
          <div className="audit-detail-tab__label audit-detail-tab__label--value">
            {getLastAuditPeriod(template.last_audit_period)}
          </div>
        </div>
        <div className="col-md-6 pl_0">
          <div className="audit-detail-tab__label">
            {t('audit.detail-tab.labels.next_audit_period')}
          </div>
          <div className="audit-detail-tab__label audit-detail-tab__label--value">
            {getNextAuditPeriod(template.next_audit_period)}
          </div>
        </div>
      </div>

      <div className="row pt_12">
        <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.recurring')}</div>
        <div className="audit-detail-tab__label audit-detail-tab__label--value">
          {auditRecurringFormatter(template.recurrence_attributes)}
        </div>
      </div>

      <div className="row pt_12">
        <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.used_count')}</div>
        <div className="audit-detail-tab__label audit-detail-tab__label--value">
          {template.used_count}
        </div>
      </div>

      <div className="row pt_12">
        <div className="pl_0 width_100">
          <div className="ap-checkbox">
            <div className="ap-checkbox__control">
              <input
                type="checkbox"
                className="ap-checkbox__input_disabled"
                checked={template.gps_location}
              />
              <label className="ap-checkbox__label">
                {t('audit.detail-tab.labels.record-gps')}
              </label>
            </div>
            <div className="ap-checkbox__control">
              <input
                type="checkbox"
                className="ap-checkbox__input_disabled"
                checked={template.asset_details}
              />
              <label className="ap-checkbox__label">
                {t('audit.detail-tab.labels.show-asset')}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="row pt_12">
        <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.group')}</div>
      </div>
      <div className="audit-expand__column row">
        <GroupTabs data={template.audit_entities_attributes} />
      </div>

      <div className="row mt_15">
        <div className="audit-detail-tab__label">{t('audit.detail-tab.labels.assign-users')}</div>
        <div className="audit-detail-tab__scroll col-12 pl_0">{renderAssignedUsers()}</div>
      </div>
      <div className="text_center mt_25">
        <Button onClick={paneState.openExpand} className="audit-detail-tab__button row">
          <i
            className="audit-icon--expand audit-icon--14 audit-icon--white mr_8"
            aria-hidden="true"
          ></i>
          {t('audit.detail-tab.labels.expand')}
        </Button>
      </div>
    </div>
  )
}

export default AuditTemplateDetailTab
